module.exports = __webpack_public_path__ + "img/logo.886c87b8.svg";